import React from 'react';
import {
  flexRender,
} from "@tanstack/react-table";

import * as CommonIcons from '../../CommonIcons';
import Dropdown from 'react-bootstrap/Dropdown';

export default function TableRows({ table, styles, isRowHover, rowStyle, cellStyle, innerCellStyle, allowWrapStyle, headerNameStyle, valueStyle, onRowClick, dropDownMenuActions, renderExpandedRow }) {
  if (styles) {
    if (!rowStyle) rowStyle = isRowHover ? `${styles.row} ${styles.hoverable}` : styles.row;
    if (!cellStyle) cellStyle = styles.cell;
    if (!innerCellStyle) innerCellStyle = styles.innerCell;
    if (!allowWrapStyle) allowWrapStyle = styles.allowWrap;
    if (!headerNameStyle) headerNameStyle = styles.headerName;
    if (!valueStyle) valueStyle = styles.value;
  }

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div      
      ref={ref}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </div>
  ));
  CustomToggle.displayName = 'CustomToggle';

  return (
    <>
      {table.getRowModel().rows.map(row => {
        return (
          <React.Fragment key={row.id}>
          <div className={rowStyle} onClick={() => { if (onRowClick) onRowClick(row.original) }}>
            <>
              {dropDownMenuActions && dropDownMenuActions.length > 0 && (() => {
                const visibleActions = dropDownMenuActions.filter(a => !a.isVisible || a.isVisible(row.original));
                if (visibleActions.length === 0) return null;
                return (
                  <div className={styles.menu}>
                    <Dropdown drop="start" >
                      <Dropdown.Toggle as={CustomToggle} variant="transparent" id="dropdown-basic">
                        <CommonIcons.ThreeDotsMenu />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {visibleActions.map((action, index) => {
                          return (
                            <Dropdown.Item
                              key={`dd-${row.id}-${index}`}
                              as={action.as}
                              to={action.getLinkTo ? action.getLinkTo(row.original) : null}
                              onClick={action.onClick ? (e) => { e.stopPropagation(); action.onClick(row.original) } : null}
                            >
                              {action.text}
                            </Dropdown.Item>
                          )
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                );
              })()}
              {row.getVisibleCells().map(cell => {
                let hasMeta = cell.getContext().cell.column.columnDef.meta;
                // Phone-width label. A function header (the select-all checkbox) has no text to show,
                // but the div stays: label and value are paired cells of the card's two-column grid.
                const header = cell.column.columnDef.header;
                return (
                  <div key={cell.id}
                    className={`${cellStyle} ${cell.column.columnDef.className ?? ''} ${cell.column.columnDef.hideOnMobile ? styles.hideOnMobile : ''}`}                    
                  >
                    <div className={`${innerCellStyle} ${cell.column.columnDef.allowWrap ? allowWrapStyle : ''}`}>
                      <div className={headerNameStyle}>{typeof header === 'string' ? `${header}:` : null}</div>
                      <div className={valueStyle}
                        {...(hasMeta && { ...hasMeta.getCellContextInner(cell.getContext()) })}
                      >{flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                      </div>
                    </div>
                  </div>
                )
              })}
            </>
          </div>
          {/* A sibling, not a child: desktop rows are display: contents, so it spans the grid via .fullRow. */}
          {renderExpandedRow && row.getIsExpanded() && (
            <div className={`${styles.fullRow} ${styles.expandedRow}`}>
              {renderExpandedRow(row)}
            </div>
          )}
          </React.Fragment>
        )
      })}
    </>
  )
}